/** @jsx jsx */
import { jsx } from 'theme-ui'
import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { Global } from '@emotion/core'

import Footer from '../components/Footer'
import { globalStyles } from '../styles/globalStyles.js'

import Nav from './shared/Nav/Nav'

import { Space } from './shared'
import { graphql, useStaticQuery } from 'gatsby'
import CartDrawer from './cart/CartDrawer'
import useShopifyFunctions from '../hooks/useShopifyFunctions'
import LPNav from './shared/Nav/LPNav'
import theme from '../gatsby-plugin-theme-ui'
import useLoop from '../hooks/useLoopCart'
import LoopIndicator from './cart/LoopIndicator'
import Link from './shared/Typography/Link/Link'

export const ShopifyContext = React.createContext({
  setShopifyFunctions: () => null,
})

export const LoopContext = React.createContext({
  isLoopCart: false,
})

export const companyInfo = {
  address: '770 S Grand Ave, Los Angeles CA 90017',
  supportHours: 'Mon - Fri 6am - 5pm PST',
  supportNumber: '213-663-1585',
  supportEmail: 'contact@jaxxon.com',
  links: [
    {
      text: 'Tap to Text',
      link: 'sms://+12133762959&body=Hey%20JAXXON%20I%20have%20a%20question',
    },
    {
      text: 'Call an Expert',
      link: 'tel:2136631585',
      locationOnly: 'US',
    },
  ],
}

const Root = styled.div`
  font-family: ${props => props.theme.fonts.body};
`

const GET_LAYOUT_INFO = graphql`
  query LayoutInfo {
    allContentfulCart {
      nodes {
        ...ContentfulCartDetails
      }
    }
    allContentfulNavBar {
      nodes {
        ...ContentfulNavBarDetails
      }
    }
    allContentfulFooter {
      nodes {
        ...ContentfulFooterDetails
      }
    }
  }
`

const Layout = props => {
  const [cartOpen, setCartOpen] = useState(false)
  const [shopifyFunctions, setShopifyFunctions] = useState(false)
  const [cartHasItems, setCartHasItems] = useState(0)
  const [notSupportedCountry, setNotSupportedCountry] = useState(false)
  const { checkout, ...rest } = useShopifyFunctions()

  const data = useStaticQuery(GET_LAYOUT_INFO)
  function handleFirstTab(e) {
    if (e.keyCode === 9) {
      document.body.classList.add('user-is-tabbing')
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleFirstTab)
    if (checkout.loaded) {
      setCartHasItems(checkout.lineItems.length)
      setShopifyFunctions({ checkout, ...rest })
    }
  }, [checkout])

  const toggleCart = () => {
    setCartOpen(!cartOpen)
  }
  const navBar = data.allContentfulNavBar.nodes.find(n => n.defaultNav)
  const footer = data.allContentfulFooter.nodes[0]
  const cart = data.allContentfulCart.nodes[0]
  return (
    <Root className="siteRoot">
      <ShopifyContext.Provider
        value={{
          cartOpen,
          setCartOpen,
          toggleCart,
          cartHasItems,
          setCartHasItems,
          setNotSupportedCountry,
          notSupportedCountry,
          ...shopifyFunctions,
        }}
      >
        <LoopContextProvider>
          {props.pageContext.landingPageCta ? (
            <LPNav
              data={navBar}
              cta={props.pageContext.landingPageCta}
              productInfo={props.pageContext.productInfo}
              useAddToCartBtn={props.pageContext.useAddToCartBtn}
            />
          ) : (
            <Nav
              data={navBar}
              subNavLinks={props.pageContext.subNavLinks}
              subNav={props.pageContext.subNav}
            />
          )}
          <CartDrawer isOpen={cartOpen} {...cart} />

          <div
            id="main"
            sx={{ minHeight: `calc(70vh - ${theme.sizes.navHeight}px);` }}
          >
            {props.children}
          </div>

          <Footer
            spaceOnMobile={props.spaceOnMobile}
            {...companyInfo}
            brandLogo={navBar.brandLogo}
            {...footer}
            miscOnly={props.pageContext.landingPageCta}
          />
          <LoopIndicator />
          <Global styles={globalStyles} />
        </LoopContextProvider>
      </ShopifyContext.Provider>
    </Root>
  )
}

export default Layout

const LoopContextProvider = ({ children }) => {
  const [checkoutButtonIsFixed, setCheckoutButtonisFixed] = useState(false)
  const Loop = useLoop()

  return (
    <LoopContext.Provider
      value={{ ...Loop, setCheckoutButtonisFixed, checkoutButtonIsFixed }}
    >
      {children}
    </LoopContext.Provider>
  )
}
